<style lang="less">
    @import "./index.less";
</style>
<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch" label-width="90px">
            <el-form-item label="字典名称" prop="title">
                <el-input v-model="searchForm.title" placeholder="字典名称" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item label="字典类型" prop="type">
                <el-input v-model="searchForm.type" placeholder="字典类型" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <div style="padding-bottom: 10px">
            <el-button  icon="el-icon-plus" type="primary" size="small" @click="handleAddDict">添加字典</el-button>
        </div>

        <el-table :data="dicList" border style="width: 100%" size="small"  v-loading="isLoading" element-loading-text="拼命加载中">
            <el-table-column type="index" prop="index" label="#" width="60" align="center"></el-table-column>
            <el-table-column prop="title" label="字典名称"></el-table-column>
            <el-table-column prop="type" label="数值类型">
                <template slot-scope="{ row }">
                    <el-tag>{{row.type}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="description" label="备注"></el-table-column>
            <!-- <el-table-column prop="sortOrder" label="排序值"></el-table-column> -->

            <el-table-column label="操作" width="280" prop="action">
                <template slot-scope="{ row, index }">
                    <el-button type="primary" size="mini" style="margin-right: 5px" @click="handleEditDict(row)">编辑</el-button>
                    <el-button type="primary" size="mini" style="margin-right: 5px" @click="handleConfigDict(row)">配置子字典</el-button>
                    <el-button type="danger" size="mini" style="margin-right: 5px" @click="handleDelDict(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: right; padding: 10px 20px 0 0;">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 50]"  :current-page.sync="searchForm.pageNumber" :page-size="searchForm.pageSize" @current-change="handleChangePage" @size-change="handleChangePageSize"></el-pagination>
        </div>

         <!-- 添加字典 -->
        <el-dialog :title="modelForm.id ? '编辑字典' : '新增字典'" :visible.sync="isShow" width="500px">
            <el-form ref="modelForm" :model="modelForm" label-width="90px" size="small" :rules="modelFormValidate">
                <el-form-item label="字典名称" prop="title">
                    <el-input type="text" v-model="modelForm.title" clearable placeholder="请输入字典名称" style="width: 300px"/>
                </el-form-item>

                <el-form-item label="字典类型" prop="type">
                    <el-input type="text" v-model="modelForm.type" clearable placeholder="请输入字典类型" style="width: 300px"/>
                </el-form-item>
                
                <el-form-item label="备注" prop="description">
                    <el-input type="text" v-model="modelForm.description" clearable placeholder="请输入备注" style="width: 300px"/>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="text" size="small" @click="isShow = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-dialog>


        <!-- 查看子字典 -->
        <el-drawer title="配置子字典" :visible.sync="isChild" v-model="isChild" size="800px">
            <ChildComponent v-if="isChild" :parentId="parentId"></ChildComponent>
        </el-drawer>
    </div>
</template>

<script>
    import {
        getAllDictList,
        addDict,
        editDict,
        deleteDict,
    } from "./dictManage";
    import ChildComponent from "./childComponent.vue";
    import _ from "lodash";

    export default {
        name: "dic-manage",
        components: {
            ChildComponent
        },
        data() {
            return {
                searchForm: {
                    title: "",
                    type: "",
                    pageNumber: 1,
                    pageSize: 10,
                },
                isLoading: false,
                dicList: [],
                total: 0,
                isShow: false,
                isChild: false,
                partentId: "",
                modelForm: {
                    title: "",        
                    type: "",        
                    description: "",            
                },
                modelFormValidate: {
                    title: [{required: true, message: "请输入字典名称", trigger: "blur"}],
                    type: [{required: true, message: "请输入字典类型", trigger: "blur"}],
                },
                submitLoading: false
            };
        },
        methods: {
            handleConfigDict(row) {
                this.parentId = row.id;
                this.isChild = true;
            },
            handleSubmit(formName) {
                this.$refs[formName].validate((valid)=>{
                    if(valid){

                        this.submitLoading = true;
                        if(this.modelForm.id) {
                            this.handleEditDataApi();
                        } else {
                            this.handleAddDataApi();
                        }

                    }
                })
            },
            handleAddDataApi() {
                addDict(this.modelForm)
                .then(res => {
                    this.submitLoading = false;
                    let data = res.data;
                    if(data.code == 200) {
                        this.$refs.modelForm.clearValidate();
                        this.isShow = false;
                        this.$message.success(data.msg);
                        this.getAllDictList();
                    }
                })
            },
            handleEditDataApi() {
                editDict(this.modelForm)
                .then(res => {
                    this.submitLoading = false;
                     let data = res.data;
                    if(data.code == 200) {
                        this.$refs.modelForm.clearValidate();
                        this.isShow = false;
                        this.$message.success(data.msg);
                        this.getAllDictList();

                    }
                })
            },
            handleAddDict() {
                this.isShow = true;
                this.modelForm = {
                    title: "",        
                    type: "",        
                    description: "",            
                    sortOrder: 1,               
                }
            },
            handleEditDict(row) {
                this.isShow = true;
                this.modelForm = _.cloneDeep(row);
            },
            handleDelDict(row) {

                this.$confirm("您确认要删除 " + row.title + " ?", '确认删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                     // 删除
                    deleteDict(row.id).then(res => {
                        let data = res.data;
                        if (data.code == 200) {
                            this.$message.success("操作成功");
                            this.getAllDictList();
                        }
                    });
                })
            },
            handleSearch(){
                this.searchForm.pageNumber = 1;
                
                this.getAllDictList();
            },
            handleReset(){
                this.searchForm = {
                    title: "",
                    pageNumber: 1,
                    pageSize: 10,
                    sort: "createTime",
                    order: "desc"
                }
                this.getAllDictList();
            },
            handleChangePage(v){
                this.searchForm.pageNumber = v;
                this.getAllDictList();

            },
            handleChangePageSize(v){
                this.searchForm.pageSize = v;
                this.searchForm.pageNumber = 1;
                this.getAllDictList();
            },
            getAllDictList() {
                this.isLoading = true;
                getAllDictList(this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;

                    if(data.code == 200) {
                        this.dicList = data.data.records;
                        this.total = data.data.total;
                    }
                })
            }
        },
        mounted() {
            this.getAllDictList();
        }
    };
</script>